export default "__VITE_ASSET__1a0a0865__"